import {navigationRef} from "../../refrences/RootNavigation";
import {LinkingOptions, NavigationContainer} from "@react-navigation/native";
import React, {useContext} from "react";
import {createStackNavigator} from "@react-navigation/stack";
import AppConfigContext from "../../contexts/AppConfigContext";

type AppPages = {
    menuPage: any,
    loginPage: any,
    cartPage: any,
    deliveryPage: any,
    addressEditorPage: any,
    overViewPage: any,
    overProgressPage: any,
    userMenuPage: any,
    ordersHistoryPage: any,
    gamePage: any,
    ctcReceiptModal: any,
    ipgCompletionModal: any,
    notificationAccessModal: any,
    servicesModal: any,
    clientInfoEditModal: any,
    gamesModal: any,
    branchInfoModal: any,
    branchWorkingTimeModal: any,
    takeawayReceipt: any,
    pwaInstallPrompt: any,
    guestNotAllowed: any
}

type NavigatorTheme = {
    dark: boolean,
    colors: {
        primary: string,
        background: string,
        card: string,
        text: string,
        border: string,
        notification: string,
    },
};

const MainStack = createStackNavigator();

export default function AppNavigatorContainer(props: {
    pages: AppPages,
    darkTheme: NavigatorTheme,
    lightTheme: NavigatorTheme
}) {
    const scheme = useContext(AppConfigContext).theme;

    const appConfig = useContext(AppConfigContext);

    // HAAAAAAAA, ToDo: make sure it works from external links
    const pathPrefix = `${appConfig.branch}/${appConfig.orderType}/${appConfig.tableId}`;
    const linking: LinkingOptions<ReactNavigation.RootParamList> = {
        prefixes: ['https://app.meezban.net', 'http://localhost:19006'],
        config: {
            screens: {
                Menu: `${pathPrefix}/menu`,
                Login: `${pathPrefix}/login`,
                Cart: `${pathPrefix}/cart`,
                Delivery: `${pathPrefix}/delivery`,
                AddressEditor: `${pathPrefix}/address-edit`,
                Overview: `${pathPrefix}/overview`,
                OrderProgress: `${pathPrefix}/order`,
                UserMenu: `${pathPrefix}/user`,
                OrdersHistory: `${pathPrefix}/orders`,
                GameScreen: `${pathPrefix}/game`,
                TakeawayReceipt: `${pathPrefix}/receipt`,

                CTCReceipt: `${pathPrefix}/complete-ctc`,
                IPGCompletion: `${pathPrefix}/complete-ipg`,
                NotificationAccessRequest: `${pathPrefix}/notification`,
                Services: `${pathPrefix}/services`,
                ClientInfoEdit: `${pathPrefix}/client`,
                Games: `${pathPrefix}/games`,
                BranchInfoScreen: `${pathPrefix}/info`,
                BranchWorkingTime: `${pathPrefix}/time`,
                PWAInstallPrompt: `${pathPrefix}/pwa`,
                GuestNotAllowed: `${pathPrefix}/guest`,
            }
        }
    };

    return <NavigationContainer ref={navigationRef}
                                linking={linking}
                                theme={scheme == "dark" ?
                                    props.darkTheme : props.lightTheme}>

        <MainStack.Navigator screenOptions={{animationEnabled: true}}>

            <MainStack.Group screenOptions={{headerShown: false}}>

                <MainStack.Screen name="Menu" component={props.pages.menuPage}
                                  options={{title: "منو"}}/>
                <MainStack.Screen name="Login" component={props.pages.loginPage}
                                  options={{title: "ورود"}}/>
                <MainStack.Screen name="Cart" component={props.pages.cartPage}
                                  options={{title: "سبد خرید"}}/>
                <MainStack.Screen name="Delivery" component={props.pages.deliveryPage}
                                  options={{title: "محل تحویل"}}/>
                <MainStack.Screen name="AddressEditor" component={props.pages.addressEditorPage}
                                  options={{title: "مشاهده آدرس"}}/>
                <MainStack.Screen name="Overview" component={props.pages.overViewPage}
                                  options={{title: "نهایی سازی سفارش"}}/>
                <MainStack.Screen name="OrderProgress" component={props.pages.overProgressPage}
                                  options={{title: "جریان سفارش"}}/>
                <MainStack.Screen name="UserMenu" component={props.pages.userMenuPage}
                                  options={{title: "منوی کاربری"}}/>
                <MainStack.Screen name="OrdersHistory" component={props.pages.ordersHistoryPage}
                                  options={{title: "سفارشات گذشته"}}/>
                <MainStack.Screen name="GameScreen" component={props.pages.gamePage}
                                  options={{title: "سرگرمی"}}/>
                <MainStack.Screen name="TakeawayReceipt" component={props.pages.takeawayReceipt}
                                  options={{title: "فاکتور سفارش"}}/>
            </MainStack.Group>

            <MainStack.Group screenOptions={{headerShown: false, presentation: "transparentModal"}}>
                <MainStack.Screen name="CTCReceipt" component={props.pages.ctcReceiptModal}
                                  options={{title: "نهایی سازی کارت به کارت"}}/>
                <MainStack.Screen name="IPGCompletion" component={props.pages.ipgCompletionModal}
                                  options={{title: "ورود به درگاه پرداخت"}}/>
                <MainStack.Screen name="NotificationAccessRequest" component={props.pages.notificationAccessModal}
                                  options={{title: "دسترسی به نوتیفیکیشن"}}/>
                <MainStack.Screen name="Services" component={props.pages.servicesModal}
                                  options={{title: "لیست خدمات"}}/>
                <MainStack.Screen name="ClientInfoEdit" component={props.pages.clientInfoEditModal}
                                  options={{title: "ویرایش پروفایل"}}/>
                <MainStack.Screen name="Games" component={props.pages.gamesModal}
                                  options={{title: "سرگرمی"}}/>
                <MainStack.Screen name="BranchInfoScreen" component={props.pages.branchInfoModal}
                                  options={{title: "اطلاعات شعبه"}}/>
                <MainStack.Screen name="BranchWorkingTime" component={props.pages.branchWorkingTimeModal}
                                  options={{title: "ساعات کاری"}}/>
                <MainStack.Screen name="PWAInstallPrompt" component={props.pages.pwaInstallPrompt}
                                  options={{title: "نصب اپلیکیشن"}}/>
                <MainStack.Screen name="GuestNotAllowed" component={props.pages.guestNotAllowed}
                                  options={{title: "عدم دسترسی"}}/>
            </MainStack.Group>

        </MainStack.Navigator>
    </NavigationContainer>;
}